import { Validator } from '@vista-digital/validator';
import { nonEmptyStringValidator } from '../string';
import { seatAvailabilityStatusValidator } from './seat-availability-status';
export const seatAvailabilityValidator = Validator.object({
    seatId: nonEmptyStringValidator,
    status: seatAvailabilityStatusValidator
});
